import { Layout } from "antd";
import NavBar, { NavItem } from "./NavBar/NavBar";
import { Outlet, useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import Loader from "../ui/Loader";
import Container from "./Container/Container";
import Footer from "./Footer/Footer";
import { useEffect } from "react";

const { Content } = Layout;

export default function AppLayout() {
  const { user, loading } = useUser();
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;

    const storageKey = "breadcrumbHistory";
    const currentPath = `${location.pathname}${location.search}`;

    try {
      if (location.pathname === "/home") {
        window.sessionStorage.setItem(storageKey, JSON.stringify([currentPath]));
        return;
      }

      const raw = window.sessionStorage.getItem(storageKey);
      const history = raw ? JSON.parse(raw) : [];
      const safeHistory = Array.isArray(history) ? history : [];
      const lastPath = safeHistory[safeHistory.length - 1];

      const nextHistory =
        lastPath === currentPath ? safeHistory : [...safeHistory, currentPath];

      window.sessionStorage.setItem(
        storageKey,
        JSON.stringify(nextHistory.slice(-12))
      );
    } catch {
      // Ignore session storage errors
    }
  }, [location.pathname, location.search]);

  const isErrorPage = location.pathname === "/error";

  if (loading && !isErrorPage) return <Loader text="Loading user..." />;
  if (!user && !isErrorPage) return null;

  const userRole = user?.typeLabel ?? null;

  const items: NavItem[] = [
    { key: "home", label: "Início", path: "/home" },
    ...(userRole === "Team Leader"
      ? [{ key: "my-team", label: "A minha equipa", path: "/my-team" }]
      : []),
    ...(userRole === "Management" || userRole === "RH"
      ? [{ key: "all-employees", label: "Colaboradores", path: "/all-employees" }]
      : []),
    ...(userRole === "Management" || userRole === "RH" || userRole === "Team Leader" || userRole === "Internal"
      ? [{ key: "reports", label: "Relatórios", path: "/reports" }]
      : []),
  ];

  return (
    <Layout style={{ minHeight: "100vh", background: "#F9F9F9", margin: 0, padding: 0 }}>
      <NavBar items={items} />
      <Content style={{ background: "#F9F9F9", margin: 0, padding: 0 }}>
        <Container>
          <Outlet />
        </Container>
      </Content>
      <Footer />
    </Layout>
  );
}
